/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_EyebrowInputs */

const en_directory_platforms_eyebrow = /** @type {(inputs: Directory_Platforms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product platforms`)
};

const zh_directory_platforms_eyebrow = /** @type {(inputs: Directory_Platforms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品平台`)
};

/**
* | output |
* | --- |
* | "Product platforms" |
*
* @param {Directory_Platforms_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_eyebrow = /** @type {((inputs?: Directory_Platforms_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_eyebrow(inputs)
	return zh_directory_platforms_eyebrow(inputs)
});
export { directory_platforms_eyebrow as "directory.platforms.eyebrow" }